

<div class="backgroundDialog" style="width: 100%; padding: 0px;margin: auto;">



  <div style="text-align: center; width: 20%;display: inline-block;  " >
    <mat-card style="border-radius: 0px 30px 30px 0px ; color: white;
                      background-color: rgb(46, 163, 80); font-size: 20px;">
        Vincular&nbsp;Motivo
    </mat-card>
  </div>

  <div style="text-align: right; width: 78%; display: inline-block; " >
    <button (click)="closeDialog()">
      <img src="../../assets/img/icones/fecharJanela.png" width="100%">
  </button>
  </div>


  <div style="background-color: rgb(51, 68, 75); height: 30px; width: 100%; color: white; text-align: center;">
    <div style="margin-top: 7px; ">{{data.beanParameter.paraDsParametro}}</div>
  </div>

  <div style="width: 100%;">
    <table style="width: 99.8%; margin: auto;">
        <tr>
            <td style="width:100%">
                <div>


                        <table style="text-align: left; width: 100%; height: 99%;">

                            <tr style="cursor: pointer;">
                              <td style="width: 100%; height: 100%;" >
                                <mat-card class="mat-elevation-z5" style="font-size: 12px; ">





                                  <mat-card style="width: 100%; border: 1px solid rgb(51, 68, 75); padding: 5px; margin-bottom: 15px;
                                              background-color:rgb(207, 121, 1); " class="mat-elevation-z4">

                                        <mat-card style="width: 100%; border: 1px solid rgb(51, 68, 75); background-color:rgb(252, 247, 242); padding: 8; margin-bottom: 3px;" class="mat-elevation-z4">

                                          <table style="width: 100%; ">
                                            <tr>
                                              <td style="width: 73%; ">

                                                <form [formGroup]="formMotivo" novalidate>


                                                  <mat-form-field appearance="fill" style="width: 100%; font-size: 14px; font-weight: 500;">

                                                      <mat-label style="text-align: left;">
                                                        <img src="../../assets/img/icones/empresa.png" width="20px">&nbsp;&nbsp;
                                                        <b> Selecione o Motivo</b>
                                                      </mat-label>

                                                        <mat-select formControlName="motiIdCdMotivo"
                                                                      style="text-align: center; font-size: 16px; font-weight: 500;">

                                                                <mat-option *ngFor="let colunas of data.lstCmbBeanMotivo"
                                                                            [value]="colunas.motiIdCdMotivo">{{colunas.motiDsMotivo}}
                                                                </mat-option>
                                                        </mat-select>

                                                    </mat-form-field>

                                                  </form>

                                              </td>
                                              <td style="width: 02%;">&nbsp;</td>
                                              <td style="width: 25%;  text-align: left; vertical-align: top;">


                                                <!-- <div style="width: 100%; vertical-align: middle; height: 50px;">
                                                    <button mat-raised-button  type="button" (click)="vincularMotivoParametro()"
                                                            style="background-color: rgb(46, 163, 80); color: #fff; width: 99%;  font-size: 12px; height: 50px;">
                                                      Vincular motivo
                                                    </button>
                                                </div> -->
                                                <br/>
                                              </td>


                                            </tr>

                                          </table>







                                          <div style="background-color: rgb(51, 68, 75); height: 30px; width: 100%; color: white; text-align: center;">


                                              <table style="width: 100%; background-color: rgb(51, 68, 75); text-align: left; " >
                                                <tr>
                                                  <td style="width: 38%; color: white;">
                                                    &nbsp;&nbsp;Status:
                                                  </td>
                                                  <td style="width: 38%; color: white;">
                                                    Usuario:
                                                  </td>
                                                  <td style="width: 24%; color: white;">
                                                    Data do registo:
                                                  </td>
                                                </tr>
                                              </table>
                                              </div>
                                          <div style="margin-top: 0px; height: 5px; width: 100%; background-color: rgb(180, 180, 180)">&nbsp;</div>

                                          <div style=" height: 200px; overflow-y: auto; ">
                                            <mat-card class="mat-elevation-z8" style="padding: 8px;">




                                                      <table *ngFor="let statusMonitory of lstBeanStatusParametroMonitory" style="width: 100%; text-align: left; font-size: 11px;" >
                                                        <tr style="border-bottom: 1px solid grey;">
                                                          <td style="width: 40%;">
                                                            &nbsp;&nbsp;{{statusMonitory.motive.motiDsMotivo}}
                                                          </td>
                                                          <td style="width: 40%;">
                                                            {{statusMonitory.user.usuaNmUsuario}}
                                                          </td>
                                                          <td style="width: 20%;">
                                                            {{statusMonitory.mopmDhRegistro | date: 'dd/MM/yyyy HH:mm'}}
                                                          </td>
                                                        </tr>
                                                      </table>


                                            </mat-card>
                                          </div>
                                            <div style="margin-top: 0px; height: 5px; width: 100%; background-color: rgb(180, 180, 180)">&nbsp;</div>
                                            <br/>


                                          <table style="width: 100%; ">
                                            <tr>
                                              <td style="width: 90%; ">

                                                <!-- <form [formGroup]="formObservacao" novalidate>

                                                  <mat-form-field appearance="outline" style="width: 98%; font-size: 11px; font-weight: bold; ">
                                                    <mat-label>
                                                      <img src="../../assets/img/icones/assistente.png" width="20px">&nbsp;&nbsp;
                                                      <b> &nbsp; Descrição do cabeçalho  </b>
                                                      <i> &nbsp;(&nbsp;Monitoria&nbsp;)&nbsp;</i>
                                                    </mat-label>
                                                    <input matInput formControlName="observacao" style=" margin-bottom: -5px;">
                                                  </mat-form-field>

                                                </form> -->

                                              </td>
                                              <td style="width: 02%;">&nbsp;</td>
                                              <td style="width: 08%;  text-align: left; vertical-align: top;">
                                                <!-- <div style="width: 100%; vertical-align: middle; height: 50px;">
                                                    <button mat-raised-button  type="button" (click)="salvarObservacao()"
                                                            style="background-color: rgb(46, 163, 80); color: #fff; font-size: 12px; height: 50px;">
                                                            <img src="../../assets/img/icones/salvar.png" width="20px">
                                                    </button>
                                                </div>
                                                <br/> -->
                                              </td>

                                            </tr>

                                          </table>




                                        </mat-card>

                                      </mat-card>




                                </mat-card>
                              </td>
                          </tr>

                      </table>


                </div>
            </td>
        </tr>
    </table>

  </div>

</div>
